// extracted by mini-css-extract-plugin
module.exports = {"sticky-footer":"DashboardStickyFooter_sticky-footer__BSl_o","hidden":"DashboardStickyFooter_hidden__Ye5in"};